import { OcrResult } from "@finway-group/shared/lib/models"
import React from "react"

import { Col, Row } from "antd"
import moment from "moment"
import { SectionHeader } from "./shared"

interface PaymentTermsProps {
    data: OcrResult
}

export const EInvoicePaymentTerms = ({ data }: PaymentTermsProps) => {
    if (!data.eInvoiceData?.paymentTerms && !data.paymentDueDate) {
        return null
    }

    return (
        <div className="flex flex-col gap-10 mt-20">
            <SectionHeader title="Payment terms" />
            {data.eInvoiceData?.paymentTerms && (
                <div className="border-1 border-gray-200 font-medium text-xs rounded-sm p-14">
                    <span className="text-black font-medium">{data.eInvoiceData.paymentTerms}</span>
                </div>
            )}

            {data.paymentDueDate && (
                <Row className="p-4 text-xs">
                    <Col span={12}>
                        <span className="text-black">Amount due on</span>
                    </Col>
                    <Col span={12} className="text-right font-medium text-black">
                        <span>{moment(data.paymentDueDate).format("DD.MM.YYYY")}</span>
                    </Col>
                </Row>
            )}
        </div>
    )
}
